import { formatGrade } from '../../features/fullDuplexFeedback/fullDuplexModel';
import { formatBerlinDateTime } from './pdfDateTime';

function logoColumns(brandingAssets) {
  const columns = [];
  if (brandingAssets?.feuerwehrLogo) columns.push({ image: brandingAssets.feuerwehrLogo, width: 90 });
  columns.push({ text: '', width: '*' });
  if (brandingAssets?.hoehenrettungLogo) columns.push({ image: brandingAssets.hoehenrettungLogo, width: 70 });
  return columns;
}

function summaryTable(config, analysis) {
  const body = [[
    { text: 'Gerät / Kriterium', style: 'tableHeader' },
    { text: 'Mittelwert', style: 'tableHeader', alignment: 'center' },
    { text: 'Anzahl', style: 'tableHeader', alignment: 'center' },
  ]];

  (config?.deviceGroups || []).forEach((group) => {
    body.push([
      { text: group.label, bold: true, fillColor: '#E8EEF4' },
      { text: formatGrade(analysis.devices?.[group.key]?.average), bold: true, alignment: 'center', fillColor: '#E8EEF4' },
      { text: String(analysis.devices?.[group.key]?.responseCount || 0), alignment: 'center', fillColor: '#E8EEF4' },
    ]);
    group.criteria.forEach((criterion) => {
      const summary = analysis.criteria?.[criterion.key] || {};
      body.push([
        { text: criterion.label, margin: [8, 0, 0, 0] },
        { text: formatGrade(summary.average), alignment: 'center' },
        { text: String(summary.responseCount || 0), alignment: 'center' },
      ]);
    });
  });

  return {
    table: { headerRows: 1, widths: ['*', 70, 50], body },
    layout: 'lightHorizontalLines',
  };
}

function submissionTable(config, submission) {
  const body = [[
    { text: 'Gerät / Kriterium', style: 'tableHeader' },
    { text: 'Note', style: 'tableHeader', alignment: 'center' },
  ]];

  (config?.deviceGroups || []).forEach((group) => {
    body.push([
      { text: group.label, bold: true, fillColor: '#E8EEF4' },
      { text: '', fillColor: '#E8EEF4' },
    ]);
    group.criteria.forEach((criterion) => {
      const value = submission.values?.[criterion.key];
      body.push([
        { text: criterion.label, margin: [8, 0, 0, 0] },
        { text: value == null ? 'Nicht getestet' : String(value), alignment: 'center' },
      ]);
    });
  });

  return {
    table: { headerRows: 1, widths: ['*', 90], body },
    layout: 'lightHorizontalLines',
  };
}

export function buildFullDuplexFeedbackPdfDocument({
  config,
  analysis,
  submissions = [],
  brandingAssets = {},
  exportDate = new Date(),
}) {
  const content = [
    { columns: logoColumns(brandingAssets), margin: [0, 0, 0, 16] },
    { text: 'Testbetrieb – Vollduplexfunk', style: 'title' },
    { text: `Auswertung exportiert am ${formatBerlinDateTime(exportDate)}`, color: '#52606D', margin: [0, 0, 0, 14] },
    { text: `Abgegebene Bewertungsbögen: ${analysis?.submissionCount || 0}`, style: 'summary', margin: [0, 0, 0, 12] },
    summaryTable(config, analysis || {}),
  ];

  [...submissions]
    .sort((left, right) => String(left.userName || '').localeCompare(String(right.userName || ''), 'de'))
    .forEach((submission) => {
      content.push(
        { text: '', pageBreak: 'before' },
        { columns: logoColumns(brandingAssets), margin: [0, 0, 0, 14] },
        { text: submission.userName, style: 'sectionTitle' },
        { text: `Stand: ${formatBerlinDateTime(submission.updatedAt || submission.createdAt)}`, color: '#52606D', margin: [0, 0, 0, 10] },
        submissionTable(config, submission),
        { text: 'Bemerkungen', style: 'subheading', margin: [0, 14, 0, 4] },
        { text: submission.remarks || 'Keine Bemerkung' },
      );
    });

  return {
    pageSize: 'A4',
    pageMargins: [38, 42, 38, 48],
    content,
    footer: (currentPage, pageCount) => ({
      text: `Seite ${currentPage} von ${pageCount}`,
      alignment: 'center',
      color: '#667085',
      fontSize: 8,
      margin: [0, 16, 0, 0],
    }),
    styles: {
      title: { fontSize: 20, bold: true, color: '#1B3A5C', margin: [0, 0, 0, 6] },
      sectionTitle: { fontSize: 17, bold: true, color: '#1B3A5C', margin: [0, 0, 0, 4] },
      subheading: { fontSize: 12, bold: true, color: '#1B3A5C' },
      summary: { fontSize: 11, bold: true },
      tableHeader: { bold: true, color: 'white', fillColor: '#1B3A5C' },
    },
    defaultStyle: { fontSize: 9 },
  };
}

export function buildFullDuplexFeedbackPdfFilename(date = new Date()) {
  const stamp = date.toISOString().slice(0, 10);
  return `Vollduplexfunk-Auswertung-${stamp}.pdf`;
}
